var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMail = function SvgIconMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1585 0.394531H1.5847C1.27466 0.394531 1.02417 0.65502 1.02417 0.977444V12.6357C1.02417 12.9581 1.27466 13.2186 1.5847 13.2186H16.1585C16.4685 13.2186 16.719 12.9581 16.719 12.6357V0.977444C16.719 0.65502 16.4685 0.394531 16.1585 0.394531ZM15.4578 2.41287V11.9071H2.28536V2.41287L1.80191 2.02122L2.49031 1.10131L3.24001 1.70791H14.5049L15.2546 1.10131L15.943 2.02122L15.4578 2.41287ZM14.5049 1.70608L8.87159 6.26009L3.23826 1.70608L2.48855 1.09949L1.80015 2.0194L2.28361 2.41104L8.26727 7.24922C8.43935 7.38824 8.65105 7.46371 8.86896 7.46371C9.08687 7.46371 9.29857 7.38824 9.47065 7.24922L15.4578 2.41287L15.9413 2.02122L15.2529 1.10131L14.5049 1.70608Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-mail.0317d77e.svg";
export { ForwardRef as ReactComponent };